import { TextField, Box, Paper } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';

import apiReq from 'core/api';
import styles from './TextTab.module.scss';

const TextTab = () => {
  const [requirements, setRequirements] = useState('');
  const currProject = useSelector((state) => state.reducer.project.id);
  const saveTimeoutRef = useRef(null);
  const hasUnsavedChangesRef = useRef(false);
  const requirementsRef = useRef('');
  const currProjectRef = useRef(null);

  useEffect(() => {
    requirementsRef.current = requirements;
  }, [requirements]);

  useEffect(() => {
    currProjectRef.current = currProject;
  }, [currProject]);

  const { data } = useQuery({
    queryKey: ['getBusiness', currProject],
    queryFn: () => apiReq(`projects/artifacts?project_id=${currProject}`),
    gcTime: 2000,
  });

  useEffect(() => {
    if (data?.artifacts) {
      setRequirements(data.artifacts);
      requirementsRef.current = data.artifacts;
    }
  }, [data]);

  const saveToServer = (text, projectId) => {
    if (projectId && text !== undefined) {
      apiReq(`projects/artifacts?project_id=${projectId}`, 'post', {
        artifacts: text,
      });
      hasUnsavedChangesRef.current = false;
    }
  };

  const handleChange = (event) => {
    const newValue = event.target.value;
    setRequirements(newValue);
    requirementsRef.current = newValue;
    hasUnsavedChangesRef.current = true;

    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current);
    }

    saveTimeoutRef.current = setTimeout(() => {
      saveToServer(newValue, currProjectRef.current);
    }, 2000);
  };

  useEffect(() => {
    return () => {
      if (saveTimeoutRef.current) {
        clearTimeout(saveTimeoutRef.current);
      }
      if (hasUnsavedChangesRef.current && requirementsRef.current) {
        saveToServer(requirementsRef.current, currProjectRef.current);
      }
    };
  }, []);

  return (
    <Box className={styles.container}>
      <Paper className={styles.paper} elevation={0}>
        <TextField
          id="multiline-basic"
          label="Общая информация"
          multiline
          fullWidth
          onChange={handleChange}
          value={requirements}
          variant="outlined"
          placeholder="Введите текст общей информации о проекте..."
          className={styles.textField}
        />
      </Paper>
    </Box>
  );
};

export default TextTab;
